// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1l5Vh","header":"ReportDetails_header__2Inpb","title":"ReportDetails_title__2SiTS","left":"ReportDetails_left__3R9Fk"};